import type { ComponentPublicInstance } from 'vue'

import { ApplicationState } from '@/enums/ApplicationState'
import { useAppStore } from '@/stores/app'

/**
 * Handles an uncaught error from anywhere in the component tree (setup, render,
 * watchers, lifecycle hooks). Without this, such an error tears down the component tree
 * silently -- nothing logged, nothing shown to the user.
 * Logs the error with enough context to diagnose it, and puts the app into the FATAL
 * state so ErrorLayout renders instead of leaving a blank screen.
 */
export function handleGlobalError(error: unknown, instance: ComponentPublicInstance | null, info: string): void {
  console.error('[ATABASE] Uncaught application error:', error, 'lifecycle hook:', info, 'component instance:', instance)

  const app = useAppStore()
  app.setError(error instanceof Error ? error.message : String(error))
  app.setState(ApplicationState.FATAL)
}
